<template>
  <v-app id="inspire">
    <Menu :menu="menu" />
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="blue darken-3"
      dark
    >
      <v-toolbar-title class="ml-0 pl-4 toolbar-title-wr">
        <span class="hidden-sm-and-down">
          HR Engine
        </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <span v-if="isLoggedIn">
        | <a @click="useLogout" class="white--text">Logout</a></span
      >
    </v-app-bar>
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <router-view></router-view>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Menu from "@/components/Menu.vue";
import { GLOBAL } from "./config/consts";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "App",
  data() {
    return {
      myRoute: null,
      drawer: null
    };
  },
  components: {
    Menu
  },
  computed: {
    ...mapGetters(["isAdmin", "isDeveloper"]),
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    menu() {
      const list = [
        {
          icon: "mdi-view-dashboard",
          text: "Список лендингов",
          link: "/"
        }
      ];
      if (this.isDeveloper) {
        list.push({
          icon: "mdi-checkbox-multiple-blank",
          text: "Базовые блоки",
          link: `/blocks?landing_id=${GLOBAL.baseLandingId}`
        });
      }
      if (this.isAdmin) {
        list.push({
          icon: "mdi-contacts",
          text: "Пользователи",
          link: "/users"
        });
      }
      return list;
    }
  },
  methods: {
    ...mapActions(["logout"]),
    async useLogout() {
      await this.logout();
      await this.$router.push("/login");
    }
  }
};
</script>

<style>
.v-main .container.fill-height {
  align-items: flex-start;
  padding: 30px 50px;
}
.theme--light.v-data-table {
  width: 100%;
}
.v-toolbar__content a {
  color: #fff;
  text-decoration: none;
}
.v-navigation-drawer__content a {
  font: inherit;
  color: inherit;
  font-size: 0;
  text-decoration: none;
}
.v-main {
  padding: 64px 0px 0px 256px !important;
}
.router-link-exact-active * {
  color: #1976d2 !important;
}
.toolbar-title-wr {
  width: 300px;
}
</style>
